import { render, staticRenderFns } from "./MuiProgress.vue?vue&type=template&id=934a79e0&scoped=true"
import script from "./MuiProgress.vue?vue&type=script&lang=js"
export * from "./MuiProgress.vue?vue&type=script&lang=js"
import style0 from "./MuiProgress.vue?vue&type=style&index=0&id=934a79e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934a79e0",
  null
  
)

export default component.exports